<template>
  <div
      v-if="gift"
      class="c-line c-gift-line"
      :class="{ 'c-gift-line--additional': isAdditional }"
      @click="$emit('click')"
  >
    <div class="c-line__title s-font-xs">
      <q-icon
          :name="ICONS.promocode"
          color="primary"
          class="q-mr-sm"
      />
      <span class="text-weight-bold">Подарок</span>
    </div>
    <div class="c-line__value s-font-xs">
      <div class="c-gift">
        <div class="c-gift-content flex q-px-sm items-center">
          <q-img
              v-if="gift.imageSrc"
              :src="gift.imageSrc"
              class="c-gift-image q-mr-sm"
              fit="contain"
          />
          <div class="c-gift-name text-weight-medium">{{ gift.productName }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">/**
 * Компонент для отображения одного подарка в Summary
 *
 * Отображает причину (reason) слева и название + фото справа
 */
import {ICONS} from "@/assets/icons";

export interface GiftDisplay {
  ruleId: number;
  reason: string;
  productName: string;
  imageSrc: string | null;
}

interface Props {
  gift: GiftDisplay | null;
  isAdditional?: boolean;
}

withDefaults(defineProps<Props>(), {
  isAdditional: false
});

defineEmits<{
  click: [];
}>();
</script>

<style scoped lang="scss">
.c-line {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
}

.c-line__title {
  display: flex;
  align-items: center;
}

.c-line__value {
  margin-right: auto;
  flex-grow: 1;
  text-align: right;
}

.c-gift-line {
  cursor: pointer;
}

.c-gift {
  display: inline-block;
}

.c-gift-content {
  border: 1px solid #dddddd;
  border-radius: 6px;
}

.c-gift-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.c-gift-image {
  width: 27px;
  height: 27px;
}

</style>
